import type {
  ClientPortalBillingSummary,
  ClientPortalPaymentSummary,
} from './clientPortalFhirTypes';

/** Resolves client-payment rows to the service line ids shown on the Services tab. */
export function resolvePaymentServiceLineIds(
  summary: Pick<ClientPortalBillingSummary, 'serviceLines'>,
  payment: ClientPortalPaymentSummary,
): string[] {
  const lines = summary.serviceLines;
  const liveIds = new Set(lines.map((line) => line.id));

  const fromPaymentIds = (payment.serviceLineIds ?? []).filter((id) => liveIds.has(id));
  if (fromPaymentIds.length > 0) return fromPaymentIds;

  if (payment.invoiceId) {
    const byInvoice = lines
      .filter((line) => line.invoiceId === payment.invoiceId)
      .map((line) => line.id);
    if (byInvoice.length > 0) return byInvoice;
  }

  if (payment.chargeItemId) {
    const byCharge = lines
      .filter((line) => line.chargeItemId === payment.chargeItemId)
      .map((line) => line.id);
    if (byCharge.length > 0) return byCharge;
  }

  return [];
}
